{
  "autorefresh": {
    "label": "Autorefresh page",
    "refreshed_ago": "Refreshed {{distance}} ago"
  },
  "bigleaf_optimizations": "Bigleaf optimizations",
  "circuit_data_usage": {
    "data_used": "{{data}} used",
    "tooltip": {
      "reset": "This will reset with the next billing cycle on {{resetDate}}",
      "title": "Circuit data usage",
      "usage": "<b>{{dataUsed}} used</b> of <b>{{dataLimit}}</b>"
    }
  },
  "circuit_status_tooltip": {
    "blocked": {
      "text": "This circuit is offline because its data limit has been reached. You can manually unblock it in the site's configuration settings.",
      "title": "{{name}} is blocked"
    },
    "degraded": {
      "text": "Circuit has active alarms of higher severity and performance is heavily impacted. Our system will attempt to load balance traffic to other available circuits.",
      "title": "{{name}} is degraded"
    },
    "down": {
      "text": "Circuit is down and unusable. Our system will load balance traffic to other available circuits.",
      "title": "{{name}} is down"
    },
    "normal": {
      "text": "Circuit has active alarms that are typical for a circuit of this type (Satellite, Cellular, Bigleaf Wireless Connect) and may not be suitable for all traffic.",
      "title": "{{name}} is normal"
    },
    "not_configured": {
      "text": "Circuit isn’t set up yet. Please configure it in the site settings, or reach out to Bigleaf, for assistance in adding a new circuit.",
      "title": "{{name}} is not configured"
    },
    "pending": {
      "text": "Circuit has been configured and is awaiting service.",
      "title": "{{name}} is pending"
    },
    "provisioning": {
      "text": "Circuit is being configured by our technicians.",
      "title": "{{name}} is provisioning"
    },
    "since": "since {{date}}",
    "up": {
      "text": "Circuit has no active alarms. This is the healthiest a WAN circuit can be.",
      "title": "{{name}} is up"
    }
  },
  "current_site_condition": "Current site condition",
  "device_status_tooltip": {
    "down": {
      "text": "Device is offline and needs to be serviced.",
      "title": "{{name}} is down"
    },
    "pending": {
      "text": "Device has been configured and is awaiting service.",
      "title": "{{name}} is pending"
    },
    "provisioning": {
      "text": "Device is being configured by our technicians.",
      "title": "{{name}} is provisioning"
    },
    "since": "since {{date}}",
    "up": {
      "text": "Device is online and running without any issues.",
      "title": "{{name}} is up"
    }
  },
  "download_overview": "Download overview",
  "drawer": {
    "alert_content": "Alert content:",
    "header": "{{alertsCount}} Active Alerts",
    "recommended_action": "Recommended action:",
    "title": "Active alerts"
  },
  "generating_pdf": "Generating PDF",
  "header": "Overview",
  "no_data": "No data found.\nSelect a different time range or try again later.",
  "no_devices": "No devices found",
  "pdf": "{{site}} - Overview",
  "risk_level": {
    "high": "High",
    "low": "Low",
    "medium": "Medium",
    "site-outage": "Disconnected"
  },
  "severity": {
    "down": "Down severity",
    "high": "High severity",
    "low": "Low severity",
    "medium": "Medium severity"
  },
  "site_general_dashboard": "Site general dashboard",
  "site_status_tooltip": {
    "down": "This site is offline and all circuits are down",
    "healthy": "This site is up and running without any issues",
    "high": "This site has active alerts, device issues and/or circuit issues",
    "medium": "This site has active alerts, device issues and/or circuit issues",
    "pending": "This site has been configured and is awaiting service",
    "provisioning": "Your site is now being provisioned. You’ll receive an update as soon as everything is ready to go.",
    "unhealthy": "This site has active alerts, device issues and/or circuit issues"
  },
  "tabs": {
    "general": "General",
    "wan": "WAN{{wanIndex}}"
  },
  "traffic_insights": "Traffic insights",
  "widgets": {
    "alerts": {
      "all_active_alerts_button": "All active alerts",
      "all_alerts": "All alerts",
      "cta": "Alert settings",
      "down": {
        "box_title": "As of {{formatted_datetime}}",
        "header": "Site is down",
        "tooltip": "This site is offline and all circuits are down"
      },
      "header": "Active alerts",
      "healthy": {
        "box_subtitle": "Congratulations!",
        "box_title": "0 active alerts",
        "box_title_with_alerts": "There are some active alerts, but they don't contribute to your site health determination",
        "header": "Site is healthy",
        "tooltip": "This site is up and running without any issues"
      },
      "historical_button": "View historical alerts",
      "latest_alerts": "Latest alerts",
      "no_alerts": "No active alerts. Congratulations!",
      "no_risk_text": "Site Down",
      "pending": {
        "box_title": "This site has been configured and is awaiting service",
        "header": "Pending",
        "tooltip": "This site has been configured and is awaiting service"
      },
      "provisioning": {
        "box_title": "Your site is now being provisioned. You’ll receive an update as soon as everything is ready to go.",
        "header": "Provisioning",
        "tooltip": "Your site is now being provisioned. You’ll receive an update as soon as everything is ready to go."
      },
      "site_down": "The site is down",
      "unhealthy": {
        "box_title": "Latest Alerts",
        "header_limit": "100+ active alerts",
        "header_one": "{{count}} active alert",
        "header_other": "{{count}} active alerts",
        "tooltip": "This site has active alerts, device issues and/or circuit issues"
      },
      "unknown": {
        "box_title": "As of {{formatted_datetime}}",
        "header": "Site unknown"
      }
    },
    "application_sessions": {
      "header": "Identified application sessions",
      "tooltip": "The number of connections Bigleaf identified and assigned to a QoS traffic class",
      "total_sessions": "Total sessions"
    },
    "average_latency": {
      "header": "Average latency",
      "tooltip": "Round-trip time from the Bigleaf network to the site within the specified timeframe, after Bigleaf QoS optimizations"
    },
    "bandwidth_utilization": {
      "download": "Download",
      "header": "Bandwidth usage (average)",
      "threshold_alert": {
        "general": "Reaching <b>{{threshold}}%</b> of your bandwidth may cause performance issues",
        "wan": "Reaching <b>{{threshold}}%</b> of your circuit capacity may cause performance issues"
      },
      "tooltip": "Total sent and received traffic as a percentage of your Bigleaf service plan for the specified timeframe",
      "upload": "Upload"
    },
    "circuits": {
      "cellular_details": "Cellular details",
      "cta": "Circuits",
      "header": "Circuit status",
      "not_configured": "Not configured"
    },
    "data_transferred": {
      "header": "Data transferred",
      "tooltip": "The amount of sent and received traffic for each data category. View data for the entire site (General) or individual WAN circuits.",
      "total_data": "Total data"
    },
    "devices": {
      "cta": "Devices",
      "details": "Details",
      "edge_firewall": {
        "firewall": {
          "disabled": "No Firewall",
          "enabled": "Firewall enabled",
          "popover": {
            "disabled": "Firewall is currently disabled.",
            "enabled": "Site is protected by the Bigleaf builtin firewall.",
            "link": "Firewall settings",
            "title": "Builtin Firewall"
          }
        },
        "lan_clients": {
          "online": "Online",
          "popover": {
            "link": "LAN Clients",
            "offline": "Offline",
            "online": "Online",
            "title": "LAN Clients",
            "total": "Total clients"
          }
        },
        "vpn": {
          "popover": {
            "link": "VPN settings",
            "no_vpn_connections": "No VPN connections",
            "offline": "Offline",
            "online": "Online",
            "title": "VPN Connections"
          },
          "vpn": "VPN"
        },
        "wifi": {
          "disabled": "Wi-Fi Off",
          "enabled": "Wi-Fi On",
          "popover": {
            "BAND_2GHZ": "2.4 GHz",
            "BAND_5GHZ": "5 GHz",
            "disabled": "Wi-Fi is disabled.",
            "settings": "Wi-Fi settings",
            "title": "Wi-Fi Radios"
          }
        }
      },
      "header": "Device status",
      "no_devices": "No configured devices"
    },
    "issues_fixed": {
      "header": "Resolved alerts",
      "tooltip": "The number of resolved alerts for the site over the selected time period"
    },
    "major_issues_fixed": {
      "header": "Connectivity Improvements",
      "tooltip": "The amount of time Bigleaf prevented significant network problems that would have caused symptoms such as dropped calls, broken web sessions, and disconnects"
    },
    "minor_issues_fixed": {
      "header": "Performance Improvements",
      "tooltip": "The amount of time Bigleaf prevented degraded network performance that would have caused symptoms such as choppy VoIP calls and slow web applications"
    },
    "optimizations_single_circuit": {
      "not_applicable": "Not applicable",
      "not_applicable_tooltip": "Improve overall site reliability and performance by adding a circuit or enabling load‑balance mode on your backup circuit."
    },
    "packets_protected": {
      "header": "{{count}} packets protected",
      "tooltip": "Higher priority packets were protected from delays or drops by Dynamic QoS"
    },
    "qos_adaptations": {
      "header": "Dynamic QoS Optimizations",
      "tooltip": "The number of times a circuit’s bandwidth was assigned to a QoS traffic class to adapt to network conditions"
    },
    "traffic_reroutes": {
      "header": "Best Path Activations",
      "tooltip": "The number of application routing changes Bigleaf made between circuits to improve connectivity and performance"
    },
    "uptime_percentages": {
      "header": "Uptime",
      "major_issues": "Connectivity issues",
      "minor_issues": "Performance issues",
      "performance_issues_threshold_tooltip": "Higher-than-normal performance degradation.",
      "site": "Site",
      "tooltip": "Site and per-circuit uptime percentages based on packet loss. Critical issues are significant network problems that would have caused symptoms such as dropped calls, broken web sessions, and disconnects."
    }
  }
}
